import React from "react";
import "./scss/main.scss";
import Header from "./Header";
import UpperMain from "./UpperMain";
import Testimonial from "./Testimonial";
import LowerMain from "./LowerMain";
import Footer from "./Footer";
function App() {
  return (
    <>
      <Header />
      <UpperMain />
      <Testimonial />
      <LowerMain />
      <Footer />
    </>
  );
}

export default App;
